import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageHomeService } from '../../services/message-home.service';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrl: './mobile-menu.component.scss',
    standalone: false
})
export class MobileMenuComponent {
  menuItems = [
    { label: 'Agregar Artículos', icon: 'pi pi-plus-circle', route: ['/init-scanner', 'article-scanner'], severity: 'success' },
    { label: 'Paletizar Artículos', icon: 'pi pi-box', route: ['/init-scanner', 'palletization'], severity: 'info' },
    { label: 'Editar Artículos', icon: 'pi pi-file-edit', route: ['/edit-articles'], severity: 'warn' },
    { label: 'Editar Palets', icon: 'pi pi-file-edit', route: ['/edit-palet'], severity: 'warn' },
    { label: 'Gestionar Artículos', icon: 'pi pi-th-large', route: '/home/inventory/articles', severity: 'primary' },
    { label: 'Gestionar Palets', icon: 'pi pi-th-large', route: '/home/inventory/pallets', severity: 'primary' },
    { label: 'Salida de Artículos', icon: 'pi pi-minus-circle', route: ['/init-scanner', 'articles-release'], severity: 'danger' },
  ] as const;

  constructor(private router: Router, private messageHomeService: MessageHomeService, private authService: AuthService, public themeService: ThemeService) { }

  ngAfterViewInit() {
    this.messageHomeService.checkAndShowPendingMessage();
  }

  navigateTo(route: any) {
    this.router.navigate(Array.isArray(route) ? route : [route]);
  }

  logout() {
    this.authService.logout('/mobile/menu');
  }
}
